import {currency} from '@/utils';
import {calculateDiffInDays} from '@/utils';

export default {
  currency: state => amount => currency(amount, state.booking.cultureCode, state.booking.currency),

  /** get excursions and passenger data in minimal format */
  excursions: state => {
    return state.booking.excursions.map(excursion => ({
      excursionId: excursion.excursionId,
      passengerIds: excursion.passengers.filter(passenger => passenger.selected).map(passenger => passenger.passengerId)
    })).filter(excursion => excursion.passengerIds.length);
  },

  /** check if a passenger is added to the excursion array */
  passengerHasExcursion: state => (passenger, excursion) => {
    const theExcursion = state.booking.excursions.find(e => e.excursionId === excursion.id);
    if (theExcursion) {
      return theExcursion.passengers.find(p => p.passengerId === passenger.passengerId && p.selected);
    }
    return false;
  },

  /** check if a passenger is locked into an excursion */
  passengerLockedExcursion: state => (passenger, excursion) => {
    const theExcursion = state.booking.excursionData.excursions.find(e => e.id === excursion.id);
    if (theExcursion) {
      return theExcursion.passengers.find(p => p.passengerId === passenger.passengerId);
    }
    return false;
  },

  /** check if all excursion are booked */
  allExcursionsBooked: state => {
    return state.booking.excursionData.excursions.every(excursion => 
      excursion.passengers.length === state.booking.passengers.length
    );
  },

  /** check if a departure date is less then 10 days */
  daysLessThanTen: state => {
    const departureDetails = state.booking.departureDetails;
    const noFlights = state.booking.tourDate;

    let departureTimeString;

    if (departureDetails && departureDetails.departureLegs && departureDetails.departureLegs.length > 0) {
      departureTimeString = departureDetails.departureLegs[0].departureTime?.date;
    } else {
      departureTimeString = noFlights;
    }
    
    const diffInDays = calculateDiffInDays(departureTimeString);
    if (diffInDays === null) return;

    return diffInDays < 10;
  },

  /** check if a departure date is less then 12 weeks or more then 10 days */
  isDepartureWithinTwelveWeeks: state => {
    const departureDetails = state.booking.departureDetails;
    const noFlights = state.booking.tourDate;

    let departureTimeString;

    if (departureDetails && departureDetails.departureLegs && departureDetails.departureLegs.length > 0) {
      departureTimeString = departureDetails.departureLegs[0].departureTime?.date;
    } else {
      departureTimeString = noFlights;
    }

    const diffInDays = calculateDiffInDays(departureTimeString);
    if (diffInDays === null) return;

    const weeks = Math.floor(diffInDays / 7);

    return weeks < 12 && diffInDays > 10;
  },

  getBookingReferenceAlias: (state, getters, rootState) => {
    const bookingRef = rootState.route.params.id;

    if (state.booking && state.booking.bookingReferenceAlias) {
      return state.booking.bookingReferenceAlias;
    }

    return bookingRef;
  },

  takeFinalBalance: state => {
    return state.booking.takeFinalBalance;
  },

  excursionAdded: state => {
    return state.excursionAdded;
  },
}